import React, { useEffect, useContext, useState } from 'react';
import { SocketContext } from '@context/socket';
import CoinflipMiddle from './components/CoinflipMiddle';

import styles from './GameRow.module.scss';
import cn from 'classnames';

import { ReactComponent as FairnessSvg } from '@assets/svg/fairness.svg';
import padlockSvg from '@assets/svg/padlock.svg';
import privateGameTab from '@assets/svg/private-game-tab.svg';
import { ICoinflipGame } from '@api/types/Coinflip';
import CoinflipSide from './components/CoinFlipSide';
import reduxAction from '@redux/reduxAction';
import { useSelector } from 'react-redux';
import { AppState } from '@redux/stores/store';
import useEffectOnce from '@hooks/useEffectOnce';

// import useReduxState from "@hooks/useReduxState";

interface IGameRow {
    gameId: string;
    first: boolean;
    last: boolean;
    single: boolean;
    // eslint-disable-next-line no-unused-vars
    openFairnessModal?: (game: ICoinflipGame) => void;
}

function GameRow({
    first,
    last,
    gameId,
    single,
    openFairnessModal,
}: IGameRow): JSX.Element {
    const game = useSelector((state: AppState) => state.coinflipData[gameId]);

    const { isFirst, executeFirst } = useEffectOnce();
    const socket = useContext(SocketContext);

    const [gameResult, setGameResult] = useState(game.result);

    const handleFairnessClick = () => {
        if (openFairnessModal) openFairnessModal(game);
    };

    // eslint-disable-next-line no-unused-vars
    const [_forceUpdate, setForceUpdate] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setForceUpdate(new Date().getTime());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    });

    useEffect(() => {
        if (game && socket && isFirst()) {
            executeFirst();
            socket.on(`coinflip-winner-${game.uid}`, (g: ICoinflipGame) => {
                reduxAction({
                    type: 'UPDATE_SINGLE_COINFLIP_GAME',
                    arg: {
                        game: g,
                    },
                });
            });
        }
    }, [isFirst, executeFirst, game, socket]);

    if (!game) return <></>;

    return (
        <div
            className={cn(styles.container, {
                [styles.first]: first,
                [styles.last]: last,
                [styles.single]: single,
                [styles.winnerDuel]: gameResult === 'heads',
                [styles.winnerAna]: gameResult === 'tails',
            })}
        >
            <div className={styles.bgContainer}>
                <div
                    className={cn({
                        [styles.winnerDuelBg]: gameResult === 'heads',
                        [styles.winnerAnaBg]: gameResult === 'tails',
                        [styles.winnerAnaGradient]:
                            gameResult === 'tails' && gameResult,
                        [styles.winnerDuelGradient]:
                            gameResult === 'heads' && gameResult,
                        [styles.winnerAnimation]:
                            gameResult &&
                            Math.floor(Date.now() / 1000) -
                                game.game_metadata.ended_at <=
                                10,

                        /*           [styles.recent_duel]: game.result == "heads",
          [styles.recent_ana]: game.result == "tails", */
                    })}
                ></div>
            </div>

            {game.game_metadata.is_private && (
                <div className={cn(styles.privateGame)}>
                    <img
                        className={styles.background}
                        src={privateGameTab}
                        alt="private game tab background"
                    />
                    <img
                        className={styles.icon}
                        src={padlockSvg}
                        alt="private game icon"
                    />
                    <span>Private Game</span>
                </div>
            )}

            {/* Duel Side */}
            <CoinflipSide
                game={game}
                side="heads"
                styles={styles}
                gameFinished={gameResult !== null}
            />

            {/* middle column */}
            <CoinflipMiddle
                setGameResult={setGameResult}
                game={game}
                styles={styles}
                socket={socket}
            />
            {/* Ana Side */}
            <CoinflipSide
                game={game}
                side="tails"
                styles={styles}
                gameFinished={gameResult !== null}
            />
            {game.game_metadata.status !== 'active' && (
                <div
                    className={styles.fairnessBtn}
                    onClick={handleFairnessClick}
                >
                    <FairnessSvg />
                </div>
            )}
        </div>
    );
}

export default React.memo(GameRow);
